export default __webpack_public_path__ + "static/media/Icon-4.0f5fc7e1.png";